import { render, staticRenderFns } from "./EasterIsland.vue?vue&type=template&id=13cafa10&"
import script from "./EasterIsland.vue?vue&type=script&lang=js&"
export * from "./EasterIsland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports